import http from "../../httpService";
import { apiUrl } from "../../../../config.js";

const apiEndpoint = apiUrl + "/setup/customer/";

export function getBusinessSizes() {
  return http.get(apiEndpoint + "businessSizes");
}

export function saveBusinessSize(businessSize) {
  return httpSaveData("businessSize", businessSize);
}

export function deleteBusinessSize(businessSizeID) {
  return http.delete(apiEndpoint + "businessSize/" + businessSizeID);
}

export function getIndustryTypes() {
  return http.get(apiEndpoint + "industryTypes");
}

export function saveIndustryType(industryType) {
  return httpSaveData("industryType", industryType);
}

export function deleteIndustryType(industryTypeID) {
  return http.delete(apiEndpoint + "industryType/" + industryTypeID);
}

export function getSources() {
  return http.get(apiEndpoint + "sources");
}

export function saveSource(source) {
  return httpSaveData("source", source);
}

export function deleteSource(sourceID) {
  return http.delete(apiEndpoint + "source/" + sourceID);
}

export function getCountries() {
  return http.get(apiEndpoint + "countries");
}

export function saveCountry(country) {
  return httpSaveData("country", country);
}

export function deleteCountry(countryID) {
  return http.delete(apiEndpoint + "country/" + countryID);
}

export function getCustomerGroups() {
  return http.get(apiEndpoint + "customerGroups");
}

export function saveCustomerGroup(customerGroup) {
  return http.post(apiEndpoint + "customerGroup", customerGroup);
}

export function deleteCustomerGroup(customerGroupID) {
  return http.delete(apiEndpoint + "customerGroup/" + customerGroupID);
}

function httpSaveData(path, data) {
  if (data.ID === 0) {
    return http.post(apiEndpoint + path, data);
  } else {
    return http.put(apiEndpoint + path, data);
  }
}
